class Header {
  constructor() {
    this.header = document.querySelector(".site-header");
    this.scrollOffset = siteVars.header_sticky_offset;

    // Se non esiste header, esci
    if (!this.header) return;

    if (siteVars.header_sticky) {
      window.addEventListener("scroll", () => this.handleScroll());
    }
  }

  handleScroll() {
    if (!this.header) return;

    if (window.scrollY > this.scrollOffset) {
      this.header.classList.add("header-scrolled");
    } else {
      this.header.classList.remove("header-scrolled");
    }
  }
}

export default Header;
